import React from 'react'
import T from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Menu, MenuItem } from '@mui/material'

import { INVENTORY_ACTIONS } from './stateChange/const'

const InventoryActionsMenu = ({
  anchorEl = null,
  setAnchorEl = () => {},
  setAction = () => {},
  handleOpenConfirmationDialog = () => {},
  actionItemsEnabled = {},
}) => {
  const { t } = useTranslation()

  const handleMenuItemClick = (action) => {
    setAnchorEl(null)
    setAction(action)
    handleOpenConfirmationDialog()
  }

  return (
    <>
      <Menu
        data-testid={`action-menu`}
        id="options-menu"
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
      >
        {Object.entries(INVENTORY_ACTIONS).map(([actionKey, actionConfig]) => {
          return actionItemsEnabled[actionKey] ? (
            <MenuItem
              key={actionKey}
              data-testid={actionConfig.dataId}
              onClick={() => handleMenuItemClick(actionConfig.action)}
            >
              {t(actionConfig.label)}
            </MenuItem>
          ) : null
        })}
      </Menu>
    </>
  )
}

InventoryActionsMenu.propTypes = {
  anchorEl: T.any,
  setAnchorEl: T.func,
  setAction: T.func,
  handleOpenConfirmationDialog: T.func,
  actionItemsEnabled: T.object,
}

export default InventoryActionsMenu
